import { render, staticRenderFns } from "./param-examens.html?vue&type=template&id=7bd55c18&scoped=true&external"
import script from "./param-examens.js?vue&type=script&lang=js&external"
export * from "./param-examens.js?vue&type=script&lang=js&external"
import style0 from "./param-examens.scss?vue&type=style&index=0&id=7bd55c18&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd55c18",
  null
  
)

export default component.exports